import _classCallCheck from "C:/Users/lek-bit/Documents/jobs/2020/pannana_ml/app/pannana_ml_admin_frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getCoordsDataType } from './shader_compiler';
export var SelectProgram = function SelectProgram(cRank, shape, rank) {
  _classCallCheck(this, SelectProgram);

  this.variableNames = ['c', 'a', 'b'];
  this.outputShape = shape;
  var cCoords;
  var abCoords;

  if (rank > 4) {
    throw Error("Where for rank ".concat(rank, " is not yet supported"));
  }

  if (rank === 1) {
    abCoords = "resRC";
    cCoords = "resRC";
  } else {
    var currentCoords = ['resRC.x', 'resRC.y', 'resRC.z', 'resRC.w'];
    var cCoordVars = [];
    var abCoordVars = [];

    for (var i = 0; i < shape.length; i++) {
      abCoordVars.push("".concat(currentCoords[i]));

      if (i < cRank) {
        cCoordVars.push("".concat(currentCoords[i]));
      }
    }

    cCoords = cCoordVars.join();
    abCoords = abCoordVars.join();
  }

  var dtype = getCoordsDataType(rank);
  this.userCode = "\n      void main() {\n        ".concat(dtype, " resRC = getOutputCoords();\n        float cVal = getC(").concat(cCoords, ");\n        if (cVal >= 1.0) {\n          setOutput(getA(").concat(abCoords, "));\n        } else {\n          setOutput(getB(").concat(abCoords, "));\n        }\n      }\n    ");
};